/* PalletStash motion: smooth FAQ accordions and a fade + slide-up reveal on load
   and scroll. Only opacity/transform/height are animated and helper classes are
   removed afterwards, so the layout is never changed. Cart drawer motion lives
   in palletstash.js + ps-motion.css. */
(function () {
  'use strict';

  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- FAQ accordions ---------- */
  function initAccordions() {
    if (reduced || !Element.prototype.animate) return;
    document.querySelectorAll('.prose details').forEach(function (item) {
      var summary = item.querySelector('summary');
      if (!summary || item.hasAttribute('data-ps-accordion')) return;
      item.setAttribute('data-ps-accordion', '');
      var anim = null;
      var target = item.open;

      function closedHeight() {
        var cs = getComputedStyle(item);
        return summary.offsetHeight + parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom) +
          parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth);
      }
      function body() {
        return Array.prototype.filter.call(item.children, function (c) { return c !== summary; });
      }

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        var start = item.offsetHeight;
        if (anim) anim.cancel();
        body().forEach(function (c) { c.getAnimations().forEach(function (a) { a.cancel(); }); });
        target = !target;
        item.classList.toggle('is-closing', !target);
        item.style.overflow = 'hidden';
        item.open = true;
        var end = target ? item.offsetHeight : closedHeight();
        anim = item.animate({ height: [start + 'px', end + 'px'] }, { duration: target ? 550 : 420, easing: EASE });
        body().forEach(function (c) {
          if (target) c.animate({ opacity: [0, 1], transform: ['translateY(-6px)', 'none'] }, { duration: 450, delay: 80, easing: EASE, fill: 'backwards' });
          else c.animate({ opacity: [1, 0] }, { duration: 220, easing: 'ease-out', fill: 'forwards' });
        });
        anim.onfinish = function () {
          item.open = target;
          item.classList.remove('is-closing');
          item.style.overflow = '';
          body().forEach(function (c) { c.getAnimations().forEach(function (a) { a.cancel(); }); });
          anim = null;
        };
      });
    });
  }

  /* ---------- reveal on load / scroll ---------- */
  var REVEAL = [
    '.hero .wrap > div:first-child > *', '.hero-art',
    '.strip .wrap > div',
    '.sec-head > *', '.grid > .card', '.cats', '.steps > div',
    '.prose > *', '.cart-page > *',
    '.crumbs', '.pdp > *',
    'footer .cols > div', 'footer .fine'
  ].join(',');

  function initReveal() {
    var root = document.documentElement;
    if (!root.classList.contains('ps-reveal-pending')) return;
    if (!('IntersectionObserver' in window)) { root.classList.remove('ps-reveal-pending'); return; }

    function done(el) {
      el.classList.remove('ps-rv', 'ps-rv-in');
      el.style.transitionDelay = '';
    }

    var io = new IntersectionObserver(function (entries) {
      var shown = entries.filter(function (e) { return e.isIntersecting; }).map(function (e) { return e.target; });
      shown.sort(function (a, b) {
        var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect();
        return (ra.top - rb.top) || (ra.left - rb.left);
      });
      shown.forEach(function (el, n) {
        io.unobserve(el);
        var delay = Math.min(n * 0.09, 0.54);
        el.style.transitionDelay = delay + 's';
        el.classList.add('ps-rv-in');
        setTimeout(function () { done(el); }, (delay + 0.85) * 1000);
      });
    }, { rootMargin: '0px 0px -40px 0px', threshold: 0 });

    document.querySelectorAll(REVEAL).forEach(function (el) {
      if (el.closest('.drawer')) return;
      el.classList.add('ps-rv');
      io.observe(el);
    });
    root.classList.remove('ps-reveal-pending');
  }

  function init() {
    initAccordions();
    initReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: re-bind accordions when a section is re-rendered.
  document.addEventListener('shopify:section:load', initAccordions);
})();
